// Utility functions for swiper management

// Check if we're on mobile
function isMobile() {
  return window.innerWidth < 768;
}

// Helper to get current mode
function getCurrentMode() {
  return document.body.getAttribute('data-card-mode') || 'produit';
}

// Initialize a swiper instance
function initializeSwiper(swiperEl, options = { draggable: true }) {
  const navNext = swiperEl.querySelector('.swiper-button-next');
  const navPrev = swiperEl.querySelector('.swiper-button-prev');
  // Get the correct start index based on mode
  const mode = getCurrentMode();
  const startIndex = mode === 'produit' ? 0 : 1; // produit = 0, modele = 1

  return new Swiper(swiperEl, {
    loop: true,
    speed: 500,
    effect: 'creative',
    creativeEffect: {
      prev: {
        translate: ["-20%", 0, -1],
        origin: "center center",
      },
      next: {
        translate: ["100%", 0, 0],
        origin: "center center",
      },
    },
    fadeEffect: {
      crossFade: true
    },
    initialSlide: startIndex,
    touchRatio: options.draggable ? 1 : 0,
    touchAngle: 45,
    navigation: {
      nextEl: navNext,
      prevEl: navPrev,
    },
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    on: {
      init: function () {
        const card = swiperEl.closest('.card');
        const progressBars = card.querySelectorAll('.progress-bar');
        progressBars.forEach(bar => bar.classList.remove('active'));
        progressBars[startIndex]?.classList.add('active');
      },
      slideChange: function () {
        const card = swiperEl.closest('.card');
        const progressBars = card.querySelectorAll('.progress-bar');
        progressBars.forEach(bar => bar.classList.remove('active'));
        progressBars[this.realIndex]?.classList.add('active');
      }
    }
  });
}

// Initialize all product card swipers
function initializeAllProductCardSwipers() {
  const cards = document.querySelectorAll('.card-wrapper');
  cards.forEach((card) => {
    // Skip if already initialized
    if (card.swiperInstance) return;

    const swiperEl = card.querySelector('.product-card-swiper');
    if (swiperEl) {
      const swiper = initializeSwiper(swiperEl, { draggable: isMobile() });
      // Use the correct index based on current mode instead of global function
      const mode = getCurrentMode();
      const correctIndex = mode === 'produit' ? 0 : 1;
      swiper.slideTo(correctIndex, 0);
      card.swiperInstance = swiper;

      // Track hover state
      let isHovering = false;
      let isManualNavigation = false;

      // Add navigation click behavior to ensure creative effect
      const navNext = card.querySelector('.swiper-button-next');
      const navPrev = card.querySelector('.swiper-button-prev');
      
      if (navNext) {
        navNext.addEventListener('mousedown', () => {
          isManualNavigation = true;
          swiper.params.effect = 'creative';
          swiper.update();
        });
      }
      
      if (navPrev) {
        navPrev.addEventListener('mousedown', () => {
          isManualNavigation = true;
          swiper.params.effect = 'creative';
          swiper.update();
        });
      }

      // Reset manual navigation flag after slide change
      swiper.on('slideChangeTransitionEnd', () => {
        isManualNavigation = false;
      });

      // Add hover behavior
      card.addEventListener('mouseenter', () => {
        if (!isManualNavigation) {
          isHovering = true;
          const mode = getCurrentMode();
          
          // Properly configure fade effect
          swiper.params.effect = 'fade';
          swiper.params.fadeEffect = {
            crossFade: true
          };
          swiper.params.speed = 400;
          swiper.update();

          if (mode === 'modele') {
            swiper.slideToLoop(0, 400);
          } else if (mode === 'produit') {
            swiper.slideToLoop(1, 400);
          }
        }
      });

      card.addEventListener('mouseleave', () => {
        isHovering = false;
        const mode = getCurrentMode();
        
        // Ensure fade effect is properly configured for mouse leave
        swiper.params.effect = 'fade';
        swiper.params.fadeEffect = {
          crossFade: true
        };
        swiper.params.speed = 400;
        swiper.update();
        
        if (mode === 'modele') {
          swiper.slideToLoop(1, 400);
        } else if (mode === 'produit') {
          swiper.slideToLoop(0, 400);
        }

        // Switch back to creative effect after fade transition completes
        setTimeout(() => {
          swiper.params.effect = 'creative';
          swiper.params.speed = 500;
          swiper.params.slidesPerView = 1;
          swiper.params.spaceBetween = 0;
          swiper.update();
        }, 400);
      });
    }
  });
}